skrilla.controller('voidUserBetsModalCtrl', function ($scope, searchService, cacheService, modalService, currencyService) {
    $scope.cancelledIds = [];
    $scope.betsToCancel = [];
    $scope.canClose = true;
    $scope.btnDisabled = false;
    $scope.message = "";
    $scope.bets = cacheService.getObjectOrElse("userBetsToVoid", function(){
        modalService.dismissAll();
    });

    $scope.bets.forEach(function(bet){
        bet.selected = true;
    });

    $scope.clicked = function(bet){
        bet.selected = !bet.selected
        console.log(bet)
    };
    
    $scope.voidBets = function () {
        if($scope.message.length === 0){
            alert("You must enter a reason!")
        }
        else {
            $scope.btnDisabled = true;
            modalService.confirm("Are you sure you'd like to void these bets?", function () {
                $scope.betsToCancel = $scope.bets.filter(function (bet) {
                    return bet.selected;
                });
                $scope.canClose = false;
                cancelBets(0);
            }, function(){
                $scope.btnDisabled = false;
            });
        }
    }

    $scope.close = function(){
        modalService.dismissAll();
    }

    function cancelBets(i){
        if(i < $scope.betsToCancel.length) {
            let bet = $scope.betsToCancel[i];
            searchService.put("bets/" + bet.id + "/cancel", {message: $scope.message}).then(function (response) {
                if(response.data.sendToBr) {
                    $scope.cancelledIds.push(bet.id);
                }
                bet.status = "CANCELLED";
                bet.reason = $scope.message;
                cancelBets(i +1)
            });
        }
        else{
            $scope.canClose = true;
        }
    }

});